import { v4 as uuidv4 } from 'uuid';
import { VapiEventSchema, type VapiEvent } from './schemas/vapiEvent';

interface VapiEventContext {
  callId: string;
  userId: string;
  campaignId: string;
  prospectId: string;
  prospectLabel: string;
}


export function buildVapiEvent(
  toolName: 'log_consent' | 'log_contact' | 'notify_owner' | 'log_appointment_confirmed' | 'create_follow_up_call' | 
           'schedule_confirmed' | 'consent_callback' | 'consent_callback_general' | 'email_and_followup_consent' | 
           'do_not_call' | 'wrong_number' | 'reschedule_confirmed' | 'info_email_request',
  args: Record<string, any>,
  context: VapiEventContext
): VapiEvent {
  return {
    type: "assistant-tool-call",
    call: {
      id: context.callId,
      metadata: {
        userId: context.userId,
        campaignId: context.campaignId,
        prospectId: context.prospectId,
        prospectLabel: context.prospectLabel,
      },
    },
    data: {
      toolName,
      args,
    },
    event_id: uuidv4(),
  };
}

export async function sendWebhookEvent(payload: VapiEvent, webhookUrl: string): Promise<void> {
  // Validate payload with Zod before sending
  try {
    VapiEventSchema.parse(payload);
  } catch (error: any) {
    const errorMsg = `Invalid payload schema: ${error.issues?.[0]?.message || error.message}`;
    console.error(errorMsg);
    throw new Error(errorMsg);
  }

  try {
    const response = await fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      const errorMsg = `Webhook failed: ${response.status} ${response.statusText} - ${errorText}`;
      console.error(errorMsg);
      throw new Error(errorMsg);
    }
  } catch (error: any) {
    const errorMsg = `Webhook exception: ${error.message}`;
    console.error(errorMsg);
    throw new Error(errorMsg);
  }
}

export async function checkWebhookConnectivity(webhookUrl: string): Promise<void> {
  try {
    const response = await fetch(`${webhookUrl}?ping=1`, {
      method: 'GET',
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Webhook unreachable: ${response.status} - ${errorText}`);
    }
    
    const responseText = await response.text();
    if (responseText !== 'ok') {
      throw new Error(`Unexpected ping response: ${responseText}`);
    }
    
  } catch (error: any) {
    throw new Error(`Webhook connectivity check failed: ${error.message}`);
  }
}